import { ProductType } from '@inter-ikea-storageone/range';
import { Product } from '@inter-ikea-storageone/range';

const findAddableFrames = (products: Product[], design: string, height: number, depth: number) => {
  return products.reduce((acc: Product[], curr: Product) => {
    if (curr.type !== ProductType.PAX_FRAME) {
      return acc;
    }
    if (
      curr.design === design &&
      curr.communicatedDimensions.depth === depth &&
      curr.communicatedDimensions.height === height
    ) {
      const sizeFound = acc.find(
        product => product.communicatedDimensions.width === curr.communicatedDimensions.width
      );

      if (!sizeFound) {
        return [...acc, curr];
      }
    }
    return acc;
  }, []);
};

export default findAddableFrames;
